angular.module("vgresiduos").controller("DocumentEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `fornecedor/documento/${$stateParams.documentId}`, getQueries());
		};

		function getQueries() {
			const queries = [];
			if ($stateParams.documentRequestId) {
				queries.push({ key: "documentRequestId", value: $stateParams.documentRequestId });
			}
			return queries;
		}
	}
]);
